module.exports = __webpack_public_path__ + "img/howitworks1.bdd31f37.png";